var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9276 0.411637C15.8682 0.288419 15.7753 0.184437 15.6595 0.111625C15.5438 0.0388137 15.4098 0.000124932 15.273 5.12397e-08H0.727548C0.590506 -5.13813e-05 0.456239 0.0386178 0.340217 0.111552C0.224196 0.184486 0.131141 0.288716 0.0717776 0.412232C0.0124137 0.535749 -0.010844 0.673524 0.00468445 0.809683C0.0202129 0.945842 0.0738955 1.07484 0.159546 1.18182L5.81847 8.25529V15.2728C5.81843 15.4166 5.86104 15.5572 5.94092 15.6768C6.02079 15.7964 6.13433 15.8897 6.2672 15.9448C6.35544 15.9816 6.45014 16.0003 6.54574 16C6.73861 16 6.92357 15.9233 7.05993 15.7869L9.96902 12.8778C10.1054 12.7415 10.1821 12.5565 10.1821 12.3637V8.25529L15.841 1.18182C15.9266 1.07466 15.9801 0.945493 15.9955 0.809218C16.0108 0.672943 15.9872 0.535115 15.9276 0.411637Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.64bf0d56358b6b367c99dd413701b8b8.svg";
export { ForwardRef as ReactComponent };